import { createStore } from "vuex";
import { api } from "@/services/api";

const storedClient = JSON.parse(
  localStorage.getItem("ondjilamed_client") || "null",
);

export default createStore({
  state: {
    token: localStorage.getItem("ondjilamed_client_token"),
    client: storedClient,
    favorites: [],
  },
  getters: {
    authenticated: (state) => Boolean(state.token && state.client),
    client: (state) => state.client,
    favoriteIds: (state) => state.favorites.map((item) => Number(item.id)),
  },
  mutations: {
    SET_SESSION(state, payload) {
      state.token = payload.token;
      state.client = payload.cliente;
    },
    SET_CLIENT(state, client) {
      state.client = client;
    },
    CLEAR_SESSION(state) {
      state.token = null;
      state.client = null;
      state.favorites = [];
    },
    SET_FAVORITES(state, favorites) {
      state.favorites = favorites;
    },
  },
  actions: {
    saveSession({ commit }, payload) {
      localStorage.setItem("ondjilamed_client_token", payload.token);
      localStorage.setItem("ondjilamed_client", JSON.stringify(payload.cliente));
      commit("SET_SESSION", payload);
    },
    async login({ dispatch }, credentials) {
      const { data } = await api.post("/client/auth/login", credentials);
      dispatch("saveSession", data);
      return data;
    },
    async register({ dispatch }, form) {
      const { data } = await api.post("/client/auth/register", form);
      dispatch("saveSession", data);
      return data;
    },
    async restore({ commit, state }) {
      if (!state.token) return false;
      try {
        const { data } = await api.get("/client/profile");
        localStorage.setItem("ondjilamed_client", JSON.stringify(data));
        commit("SET_CLIENT", data);
        return true;
      } catch (_) {
        commit("CLEAR_SESSION");
        return false;
      }
    },
    async logout({ commit }) {
      try {
        await api.post("/client/logout");
      } catch (_) {
        // A sessão local deve ser encerrada mesmo sem ligação ao servidor.
      }
      localStorage.removeItem("ondjilamed_client_token");
      localStorage.removeItem("ondjilamed_client");
      commit("CLEAR_SESSION");
    },
    async loadFavorites({ commit, state }) {
      if (!state.token) return;
      const { data } = await api.get("/client/favoritos");
      commit("SET_FAVORITES", data);
    },
  },
});
